
import { content } from 'html2canvas/dist/types/css/property-descriptors/content';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { qrCodeTemplate, addQrCodeTemplate, editorQrCodeTemplate, deleteQrCodeTemplate } from '@/api/customer';
import { UserModule } from '@/store/modules/user';
import { Qiniu } from '@/types/qiniu';
import { getQiniuToken } from '@/api/third';
import { makeKey } from '@/utils/qiniu';

@Component({
  name: 'CustomerQrcodeTemplate',
  components: {

  }
})
export default class extends Vue {
  private bgImage= ''
  private templateList: any = []
  private isAdded = true
  private codeSettingVisible = false

  private qiniu: any = {}
  private action: string = 'https://up-z1.qiniup.com';

  private codeSetting: any = {
    image_real_path: 'http://test-img.baoxiuguanjia.com/u/2021/09/16/yiTh2HtDBwPT1631771567907.png',
    image_save_path: '',
    content: '',
    service_providers: '',
    platform_name: '',
    web_site: ''
  }
  private rules = {
    image_real_path: [
      { required: true, message: '请上传背景图片', trigger: 'blur' }
    ],
    content: [
      { pattern: /^.{2,12}$/, message: '请输入2-12个字符', trigger: 'blur' }
    ],
    service_providers: [
      { pattern: /^.{2,30}$/, message: '请输入2-30个字符', trigger: 'blur' }
    ],
    platform_name: [
      { pattern: /^.{2,15}$/, message: '请输入2-15个字符', trigger: 'blur' }
    ],
    web_site: [
      { pattern: /^.{5,35}$/, message: '请输入5-35个字符', trigger: 'blur' }
    ]
  }
  private disabledbtn = false

  created() {
    this.qrCodeTemplate();
  }
  private getQiniuToken() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_OTHER
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
  }
  private form={}
  private handleUploadImgSuccess(val: any) {
    this.codeSetting.image_real_path = this.qiniu.default_url + val.key;
    this.codeSetting.image_save_path = val.key;
  }
  private beforeUploadImg(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 ' +
      5 + 'MB!');
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 模版
  private qrCodeTemplate() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    qrCodeTemplate(pamars).then(res => {
      if (res.data) {
        this.templateList = res.data;
      } else {
        this.templateList = [];
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  private addTemplate() {
    this.isAdded = true;
    this.codeSettingVisible = true;
    if (this.qiniu && this.qiniu.domain) {
      return;
    }
    this.getQiniuToken();
  }
  private editTemplate(val: any) {
    this.isAdded = false;
    this.codeSettingVisible = true;
    this.codeSetting = {
      id: val.id,
      image_real_path: val.image_real_path,
      image_save_path: val.image_save_path,
      content: val.content,
      service_providers: val.service_providers,
      platform_name: val.platform_name,
      web_site: val.web_site
    };
    if (this.qiniu && this.qiniu.domain) {
      return;
    }
    this.getQiniuToken();
  }
  private deleteTemplate(val: any) {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.id = val.id;
    deleteQrCodeTemplate(pamars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.qrCodeTemplate();
    }).catch(err => {
      let msg = err.msg;
      this.showErrorMsg(msg);
    });
  }
  private templateSubmit() {
    (this.$refs.codeSetting as any).validate((valid: any) => {
      if (!valid) {
        return false;
      }
      this.addOrEditor();
    });
  }
  private addOrEditor() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.image_save_path = this.codeSetting.image_save_path;
    pamars.content = this.codeSetting.content;
    pamars.service_providers = this.codeSetting.service_providers;
    pamars.platform_name = this.codeSetting.platform_name;
    pamars.web_site = this.codeSetting.web_site;
    if (this.isAdded) {
      addQrCodeTemplate(pamars).then((res:any) => {
        this.showSecussMsg(res.msg);
        this.qrCodeTemplate();
        this.codeSettingVisible = false;
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    } else {
      pamars.id = this.codeSetting.id;
      editorQrCodeTemplate(pamars).then((res:any) => {
        this.showSecussMsg(res.msg);
        this.qrCodeTemplate();
        this.codeSettingVisible = false;
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }
  }
  private editor() {

  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}

